import { useTranslation } from "react-i18next";
import Select from "../common/components/Select"
import { realizeContactLists, useContactLists } from "../reducers/contactSlice";

export const customCtrlDef = {
    toString: async ({ value, defaultValue, ...props }) => {
        if (!value) {
            return defaultValue;
        }
        let contactLists = await realizeContactLists({ ...props });
        return contactLists.find(l => l.id == value)?.name ?? value;
    },
    control: ({ value, def, ...props }) => <ContactListDropdown value={value} placeholder={def.placeholder} wildcard={def.wildcard} {...props}></ContactListDropdown>
}

const ContactListDropdown = ({ placeholder, onChange, ...props }) => {
    const { t } = useTranslation();
    const contactLists = useContactLists();
    return <Select className="mb-2" placeholder={placeholder ?? t('list')} options={contactLists} labelField="name" valueField="id" onChange={onChange} {...props}></Select>
}

export default ContactListDropdown;